/**
 * onlinekatalog.js
 * 
 * Stellt Methoden zur erweiterten Nutzung des Scene7 eCatalog bereit die es ermöglichen Produkte aus dem 
 * Online-Katalog in den Warenkorb zu legen.
 * 
 * @version     1.0.0
 * @author      Erwin Müller Versandhaus GmbH
 */
$(function(){
  var fixUrl = true;
  var xmlStateInfo = "";

  function fixURL( product_url ) {
    if ( product_url.indexOf("http://") == -1 && product_url.indexOf("https://") == -1 ) product_url = "http://" + callBack + product_url;
    if ( urlPassBack != "" ) {
      product_url += ( product_url.indexOf("?") == -1) ? '?' : '&';
      product_url += urlPassBack;
    }

    return product_url;
  }

  function loadProduct( product_url ) {
    loadProductPW(product_url);
  }

  function loadProductPW( product_url ) {
    $("#warenkorbMeldung").stop(true, true).hide();
    
    // Artikelnummer mit Hilfe einer regular expression aus der Produkt-URL filtern
    var artnr = product_url.match(/[0-9]+/);
    
    // Artikelansicht einblenden
    $("#katArtAnsicht").fadeIn(400);

    $("#katArtAnsichtInhalt").hide();
    $("#wrapperLoaderror").hide();      
    $("#wrapperAjaxload").show();

    $.ajax({
      type:       "POST",
      data:       "ajax=true&aktion=onlinekat&bestellnr="+artnr,
      dataType:   "json",
      success: function(data){ 
        if ( data.artBez == "" && data.artBeschr == "" ) {
          setTimeout(function(){
            $("#wrapperAjaxload").hide();
            $("#wrapperLoaderror").show();
          }, 500);
        } else {
          // Anzahl der Ausführungen (Farben)
          var anzahlAusfuehrungen = data.ausfuehrungen.length;
          var farbeSelect = data.farbeSelect;
          var groesseSelect= data.groesseSelect;
          
          // Artikelbeschreibung und Titel können schon jetzt zugewiesen werden, da sie für jede Ausführung gleich sind 
          $("#katArtikelbezeichnung").html(data.artBez);
          $("#katArtikelbeschreibung").html(data.artBeschr);

          $("#katArtAusfuehrung").html(data.AusfuehrungSelect);
        
          var durchschnittsbewertung = data.bewertung_kopf.b_durchschnitt;
          var graueSterne = 5 - durchschnittsbewertung;
        
          $("#katArtikelbewertung").empty();
          
          for ( var i = 0; i < 5; i++ ) {
            $("#katArtikelbewertung").append( ( i < durchschnittsbewertung) ? "<div class='stern sternGelb'></div>" : "<div class='stern sternGrau'></div>");
          }

          $("#katArtikelbewertung").append(data.bewertung_kopf.b_anzahl);
          $("#katArtikelbewertung").append("<div style='clear:left'>&nbsp;</div>");
        
          // leert die Select-Felder
          $("#katArtikelausfuehrungen").empty();
          $("#katArtikelgroessen").empty();
          
          // durchläuft alle Ausführungen
          $(data.ausfuehrungen).each(function(){
            
            var farbe = this.farbe;
            // Ausführungs-Select Optionen zuweisen
            if (data.ausfuehrungen.length == 1) {
              $(".katAusfuehrungen").text(farbe);
              $(".katAusfuehrungen").show();
              $("#katArtikelausfuehrungen").append("<option value='"+farbe+"'>"+farbe+"</option>");
            } else {
              $("#katArtikelausfuehrungen").append("<option value='"+farbe+"'>"+farbe+"</option>");
              $(".katAusfuehrungen").hide();
            }
          });

          $("#katArtikelausfuehrungen").off("change keyup focusout mouseup").on("change keyup focusout mouseup", function() {
            var ausfuehrungSelected = $(this).val();
            $("#katArtikelgroessen").empty();

            $(data.ausfuehrungen).each(function() {
              if( this.farbe == ausfuehrungSelected ) {      
                $(this.groessen).each(function() {
                  $("#katArtikelgroessen").append("<option value='"+this.groesse+"'>"+this.groesse+"</option>");
                });
              }
            });
            
            $("#katArtikelgroessen").val($("#katArtikelgroessen option").first().val()).trigger("change");
          });
        
          if( farbeSelect != "default" && farbeSelect != undefined ) {
            $("#katArtikelausfuehrungen").val(farbeSelect).trigger("change");
          } else {
            $("#katArtikelausfuehrungen").val($("#katArtikelausfuehrungen option").first().val()).trigger("change");
          }
        
          $("#katArtikelgroessen").off("change keyup focusout mouseup").on("change keyup focusout mouseup", function(){
            var groesseSelected = $(this).val();
            var ausfuehrungSelected = $("#katArtikelausfuehrungen").val();
          
  
            $(data.ausfuehrungen).each(function() {
              if ( this.farbe == ausfuehrungSelected ) {
                $(this.groessen).each(function() {
                  if ( this.groesse == groesseSelected ) {
                    $("#katArtikelbild").attr("src", this.daten.artikelbild);
                    $("#katArtikelpreis").html(this.daten.artikelpreis);
                    $("#katArtikellieferinfo").html(this.daten.artikellieferinfo);
                    $("#z1").html(this.daten.stattpreisDiv);
                    $("#z3").html(this.daten.grundpreisDiv);
                    $("#bestform #artikel_artnr").val(this.daten.artikelnr);
                    $("#katArtikelnummer").html(this.daten.artikelnr);
                    $("#bestform #artikel_dtid").val(this.daten.dtid);
                        
                    if( this.daten.artikellieferstatus == "0" ) {
                      $("#z4s1").css("visibility", "hidden");
                      $("#z4s2 a").removeAttr("href");
                      $("#z4s2 a span b#inDenWkMeldung").hide();
                      $("#z4s2 a span b#nichtBestellbarMeldung").show();
                    } else {
                      $("#z4s1").css("visibility", "visible");
                      $("#z4s2 a").attr("href", "Javascript:onclick=warenkorbFunktion();")
                      $("#z4s2 a span b#inDenWkMeldung").show();
                      $("#z4s2 a span b#nichtBestellbarMeldung").hide();
                    }
                  }
                });
              }
            
              if( this.groessen.length == 1 ) {
                $("#katArtikelgroessen").hide();        
                $("#katArtikelgroesse").show().html(this.groessen[0].groesse);

                if ( this.groessen[0].groesse == "default" ) {
                  $("#art_info_groesse").hide();
                } else {
                  $("#art_info_groesse").show();
                }
              } else {
                $("#katArtikelgroessen").show();
                $("#katArtikelgroesse").hide();
                $("#art_info_groesse").show();
              }
            });
          });
        
          if ( groesseSelect != "default" && groesseSelect != undefined ) {
            $("#katArtikelgroessen").val(groesseSelect).trigger("change");
          } else {
            $("#katArtikelgroessen").val($("#katArtikelgroessen option").first().val()).trigger("change");
          }
        
          if( anzahlAusfuehrungen == 1 ) {
            $("#katArtikelausfuehrungen").hide();    
            $("#katArtikelausfuehrung").show().html(data.ausfuehrungen[0].farbe);
            if ( data.ausfuehrungen[0].farbe == "default" ) {
              $("#art_info_ausfuehrung").hide();
            } else {
              $("#art_info_ausfuehrung").show();
            }
          } else {
            $("#katArtikelausfuehrungen").show();
            $("#katArtikelausfuehrung").hide();
            $("#art_info_ausfuehrung").show();
          }

          setTimeout(function(){
            $("#wrapperAjaxload").hide();
            $("#katArtAnsichtInhalt").show();
            var hoehe = parseInt($("#katArtikelbeschreibung").height());
            var maxHoehe = parseInt($("#katArtikelbeschreibung").css("max-height"));
            
            if ( hoehe > maxHoehe ) {
              $("#katArtikelbeschreibung").css("height", maxHoehe);
            } else {
              $("#katArtikelbeschreibung").removeAttr("height");
            }
          }, 500);
        }
      }
    });
      
  }

  function closeProductPW() {
    $(function() {
      $("#katArtAnsicht").hide(1000);
    })
  }

  function loadProductCW( product_url ) {
    product_url = fixURL(product_url);
    document.location = product_url;
  }

  function loadProductNW( product_url ) {
    if ( fixUrl ) product_url = fixURL(product_url);
    // should trigger popup blocker
    var new_window = window.open( product_url, windowName, windowFeatures );
    try {
      // This will throw an exception when popup blocking is enabled.
      new_window.focus();
    } catch (err) {}
  }

  function launchFeedback( currentFrame ) {
    alert( "feedback for frame " + currentFrame );
  }

  function reload( enlargeState, currentFrame ) {
    document.location = document.location.pathname + "?" + reloadParams + "&el=" + enlargeState;
  }

  function onProductIconClick() {
    loadProductPW( productIconURL );
  }

  function onLogoClick() {
    if( logoClickURL != '' ) loadProductPW( logoClickURL );
  }


  function saveState( type, stateInfo, finalBlock ) {
    var tmpSI = "";
  
    xmlStateInfo += stateInfo;
    
    if ( arguments.length < 3 ) finalBlock = true;
    if ( finalBlock ) {
      if ( type == 1 ) {  //email to a friend
        tmpSI = xmlStateInfo;
        xmlStateInfo = "";
        window.open( "","emailfriend" ,"width=" + emailWindowWidth + ",height=" + emailWindowHeight + ", location=no,menubar=no,resizable=no,scrollbars=no,status=no,toolbar=no" );
        document.frmState.currentState.value=tmpSI;
        xmlStateInfo = "";
        document.frmState.submit();
      }
    }
  }

  function openPrivacy() {
    var html = privacyCopy;
    newWin = window.open("","privacy","width=" + privacyWindowWidth + ",height=" + privacyWindowHeight);
    newWin.document.write(html);
    newWin.document.close();
  }

  function resizeStage( w, h ) {
    var elementId = 'ZoomMX';    //match the id attribute of the OBJECT element
    
    if( typeof( instance ) != 'undefined') elementId = instance;

    var isSafari = ((navigator.appName=='Safari') || (navigator.userAgent.toLowerCase().indexOf('safari')>-1));
  
    var elm = ( !isSafari ) ? document.embeds[elementId] : null;
    var checkElm = ( elm ) ? true : false;
  
    if ( !isSafari && checkElm ) {
      elm.width = w;
      elm.height= h;
    } else {
      v = getElement(elementId);
      
      if ( v ) {
        if ( document.getElementById ) {
          v.width = w;
          v.height = h;
        } else if ( v.all ) {
          v.posWidth = w;
          v.posHeight = h;
        } else if ( v.clip ) {
          v.clip.width = w;
          v.clip.height = h;
        }
      }
    }
  }

  function getElement( name ) {
    if ( document.getElementById && document.getElementById(name) ) return document.getElementById(name).style;
    if ( document.all && document.all[name] ) return document.all[name].style;
    if ( document.layers ) return document[name];
  }

  function goToPage( page ) {
    setFlashParam( instance, "currentFrame", page );
  }

  function setFlashParam(inId, inName, inVal) {
    var ua            = navigator.userAgent.toLowerCase();
    var is_pc_ie      = ( (ua.indexOf('msie') != -1 ) && ( ua.indexOf('win') != -1 ) && ( ua.indexOf('opera') == -1 ) && ( ua.indexOf('webtv') == -1 ) );
    var divcontainer  = "flash_setvariables_" + inId;
    
    if ( !document.getElementById(divcontainer) ) {
      var divholder = document.createElement("div");
      divholder.id = divcontainer;
      document.body.appendChild(divholder);
    }
    
    document.getElementById(divcontainer).innerHTML = "";

    var divinfo = "<embed src='http://images.buttinette.com/is-viewers/flash/gateway.swf' FlashVars='lc=" + inId + "&fq="+escape(inName + "=" + inVal)+"' width='0' height='0' type='application/x-shockwave-flash'></embed>";
    document.getElementById(divcontainer).innerHTML = divinfo;
  }

  function docWrite( line ) {
    document.write( line );
  }

  function ParentOpener( url, parentname ) {
    if ( self.opener && !self.opener.closed ) {
      self.opener.location=url;
    } else { 
      window.open( url, parentname );
    }
  }

  function HomeDetails( sku ) {
    var aurl = 'http://www.amazon.com/exec/obidos/tg/detail/-/'+sku.toUpperCase()+'?m=ATVPDKIKX0DER&s=merchant/ref=s7_ahe_2_s7';
    if ( self.opener && !self.opener.closed ) {
      self.opener.location = aurl;
    } else {
      window.open(aurl,'s7Amazon');
    }
  }


  function ToolsDetail( sku ) {
    var aurl = '<http://www.amazon.com/exec/obidos/tg/detail/-/'+sku.toUpperCase()+'?m=ATVPDKIKX0DER&s=merchant/ref=s7_tce_504_s7';
    if ( self.opener && !self.opener.closed ) {
      self.opener.location = aurl;
    } else {
      window.open(aurl,'s7Amazon');
    }
  }

  function BobDetails( sku ) {
    var aurl = 'http://www.amazon.com/exec/obidos/tg/detail/-/'+sku.toUpperCase()+'?m=ATVPDKIKX0DER&s=merchant/ref=s7_boe_551_s7';
    if ( self.opener&&!self.opener.closed ) {
      self.opener.location=aurl;
    } else {
      window.open(aurl,'s7Amazon');
    }
  }

  function AmazonDetail( ASIN, REF ) {
    var aurl = 'http://www.amazon.com/exec/obidos/tg/detail/-/'+ASIN.toUpperCase()+'?m=ATVPDKIKX0DER&s=merchant/ref='+REF;
    if ( self.opener&&!self.opener.closed ) {
      self.opener.location=aurl;
    } else {
      window.open(aurl,'s7Amazon');
    }
  }
});